module.exports = __webpack_public_path__ + "static/media/neutral.194f0297.svg";